import React, { FunctionComponent } from "react";
import styled from "styled-components";
import Image from "next/image";

import { colours } from "utils";
import { Device } from "utils/device";

type StyleProps = {
  colour?: string;
  textColour?: string;
};

const PartnerStrip2024Content: FunctionComponent = () => {
  return (
    <S.Container data-cy="SF-content-partner">
      <S.ImageContainer>
        <Image
          src="/images/step-forward-2025/partner-strip-2024.png"
          layout="fill"
          objectFit="contain"
          alt="a list of logos for step-forward partners"
        />
      </S.ImageContainer>
    </S.Container>
  );
};

const S = () => {};

S.Container = styled.section<StyleProps>`
  position: relative;
  width: 100%;
  padding: 0;
  background: ${colours.shell};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: ${Device.tablet}) {
    padding: 0;
    flex-direction: row;
  }
`;

S.ImageContainer = styled.div`
  position: relative;
  height: 30px;
  aspect-ratio: 9/1;

  @supports not (aspect-ratio: 3/1) {
    &::before {
      float: left;
      padding-top: 11%;
      content: "";
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }

  @media (min-width: ${Device.mobile}) {
    height: 60px;
  }

  @media (min-width: ${Device.tablet}) {
    height: 100px;
  }
`;

export default PartnerStrip2024Content;
